const swiper = new Swiper('.topbar-swiper', {
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 2000,
  },
});

document.querySelectorAll('.whatsapp').forEach(function (element) {
  element.addEventListener('click', function (e) {
    var iframe = document.getElementById('toggle-iframe');

    if (iframe && iframe.contentWindow) {
      var iframeDocument = iframe.contentWindow.document;

      var button = iframeDocument.querySelector('button');
      if (button) {
        button.click();
      }
    }
  });
});

function positionCartNotification() {

  //if (window.innerWidth < 991) return false;
  
  const smallCart = document.querySelector('#small-cart');
  const cartNotification = document.querySelector('#cart-notification');

  if (!smallCart || !cartNotification) return; // Exit if elements are not found

  // Get the bounding rectangle of the #small-cart element
  const smallCartRect = smallCart.getBoundingClientRect();

  // Calculate the target's fixed position relative to the bottom-right of #small-cart
  const targetX = smallCartRect.right;  // Right edge of #small-cart
  const targetY = smallCartRect.bottom; // Bottom edge of #small-cart

  // Position #cart-notification so its top-right corner is at the bottom-right of #small-cart
  cartNotification.style.position = 'fixed';
  if (window.innerWidth < 991) {
    cartNotification.style.left = `${targetX}px`; // Align right edges
  } else {
    cartNotification.style.left = `${targetX - cartNotification.offsetWidth}px`; // Align right edges
  }
  cartNotification.style.top = `${targetY}px`; // Align top to bottom of #small-cart

  cartNotification.style.display = 'block';
} 

// Call the positioning function initially
positionCartNotification();

window.addEventListener('load', function() {
  positionCartNotification();
})

// Add event listener for window resize
window.addEventListener('resize', positionCartNotification);
